import { Link } from "react-router-dom";

export default function Header() {
  return (
    <>
      <header className="site-header" id="siteHeader">
        <div className="container header-inner">
          <a href="#top" className="brand">
            <img
              src="/assets/website/images/logo.svg"
              alt="RouteRider logo"
              className="brand-logo"
            />
            <span className="brand-text">
              <span className="brand-name">
                Route<span className="accent-text">Rider</span>
              </span>
              <span className="brand-tag">
                Intercity Cab &amp; Seat Booking
              </span>
            </span>
          </a>
          <nav className="main-nav" id="mainNav">
            <a href="#how-it-works">How it works</a>
            <a href="#routes">Popular Routes</a>
            <a href="#safety">Safety</a>
            <a href="#testimonials">Reviews</a>
            <a href="#faq">FAQ</a>
            <Link
              to="/login?role=customer"
              className="btn btn-dark btn-sm show-mobile"
              id="loginBtnMobile"
            >
              Log in
            </Link>
          </nav>
          <div className="header-actions">
            <Link
              to="/login_customer"
              className="btn btn-outline btn-sm hide-mobile"
              id="loginBtn"
            >
              Log in
            </Link>
            <Link
              to="/signup_customer"
              className="btn btn-primary btn-sm"
              id="signupBtn"
            >
              Sign up
            </Link>
            <button
              className="nav-toggle"
              id="navToggle"
              aria-label="Toggle menu"
              aria-expanded="false"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>
    </>
  );
}
